/// <amd-module name="SuiteCommerce.CookieConsent.Shopping"/>
define("SuiteCommerce.CookieConsent.Shopping", ["require", "exports", "SuiteCommerce.CookieConsent.Common.Configuration", "SuiteCommerce.CookieConsent.Container", "SuiteCommerce.CookieConsent.CookiesHandler", "SuiteCommerce.CookieConsent.CookieConsentLinkCCT.CookieConsentCCT", "Utils"], function (require, exports, Configuration_1, Container, CookiesHandler_1, CookieSettingsCCT, Utils) {
    "use strict";
    return {
        mountToApp: function (container) {
            Configuration_1.Configuration.environment = container.getComponent('Environment');
            if (Utils.isSingleDomain()) {
                CookiesHandler_1.CookiesHandler.initCookiesHandler(container);
                Container.mountToApp(container);
                CookieSettingsCCT.mountToApp(container);
            }
        }
    };
});
